export default __webpack_public_path__ + "static/media/e654048dc0261c241940d41e37e202841598964753309.1fbefda2.webp";